import { memo, useContext, useEffect, useCallback, useState } from "react";
import {
  CatalogContext,
  IProductsCatalog,
} from "src/api/context/CatalogContext";
import { Flex, Text, Box, Button, useMantineTheme } from "@mantine/core";
import ProductSelection from "./ProductSelection";

function SelectVariant() {
  const theme = useMantineTheme();
  let color = theme.colors.secondaryTextColor[1];
  const {
    productsCart,
    selectedPG,
    handleProductSelection,
    handleVariantSelection,
    metricValues,
  } = useContext(CatalogContext);
  const { products, metrics } = selectedPG || {};
  const [activeProducts, setActiveProducts] = useState<IProductsCatalog>([]);
  const [filterProducts, setfilterProducts] = useState(activeProducts);

  useEffect(() => {
    setActiveProducts(products?.filter((p) => p.isActive) || []);
  }, [products]);

  useEffect(() => {
    setfilterProducts(activeProducts);
    if (
      activeProducts?.length === 1 &&
      activeProducts[0].stock &&
      activeProducts[0].isActive
    ) {
      !checkForProductInCart(activeProducts[0]) &&
        handleProductSelection(activeProducts[0]);
    }
  }, [activeProducts]);

  useEffect(() => {
    if (Object.keys(metricValues).length) {
      let matchingVariant = activeProducts.filter((ap) =>
        Object.entries(metricValues).every(([key, values]) =>
          values.some((val) => ap.metricValues.map((e) => e.id).includes(val))
        )
      );
      setfilterProducts(matchingVariant);
    } else {
      setfilterProducts(activeProducts);
    }
  }, [metricValues]);

  const checkForProductInCart = useCallback(
    (product: IProductsCatalog[0]) => {
      let isProductInCart = productsCart.find((p) => p.id === product.id);
      return !!isProductInCart;
    },
    [productsCart]
  );

  return (
    <>
      <Box mt={"md"}>
        {metrics?.map((m) => (
          <Flex key={m.id} gap={"md"} mt={"sm"}>
            <Text fw={600}>{m.name}:</Text>
            {m.values?.map((val) => (
              <Button
                key={val.id}
                radius="xl"
                compact
                sx={{
                  minWidth: 60,

                  backgroundColor: theme.colors.secondary[6],
                  color: color,
                  ":hover": {
                    color: theme.colors.secondaryTextColor[6],
                    backgroundColor: theme.colors.secondary[5],
                  },
                  ...(metricValues[m.id]?.includes(val.id) && {
                    backgroundColor: "dark",
                    color: "white",
                  }),
                }}
                onClick={() => handleVariantSelection(m.id, val.id)}
              >
                {val.name}
              </Button>
            ))}
          </Flex>
        ))}

        <Flex wrap={"wrap"} mt={"md"} gap={"md"}>
          {filterProducts?.map((p) => (
            <ProductSelection key={p.id} product={p} />
          ))}
        </Flex>
      </Box>
    </>
  );
}
export default memo(SelectVariant);
